/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Submit_SitemapInputs */

const en_admin_indexnow_submit_sitemap = /** @type {(inputs: Admin_Indexnow_Submit_SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit all sitemap URLs`)
};

/**
* | output |
* | --- |
* | "Submit all sitemap URLs" |
*
* @param {Admin_Indexnow_Submit_SitemapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_submit_sitemap = /** @type {((inputs?: Admin_Indexnow_Submit_SitemapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Submit_SitemapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_submit_sitemap(inputs)
});
export { admin_indexnow_submit_sitemap as "admin.indexnow.submit_sitemap" }